/* tslint:disable:no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
} else if (process.env.NODE_ENV === 'development') {
  register(`${process.env.BASE_URL}service-worker-dev.js`, {
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}
